export default __webpack_public_path__ + "static/media/coru-logo-gray-500.b00bb5b6.svg";